import React from 'react';
import AdminLayout from './AdminLayout';
import CakeForm from './CakeForm';

export default function AdminCakeNew() {
  return (
    <AdminLayout title="Add a New Cake">
      <CakeForm />
    </AdminLayout>
  );
}
